module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/babel-runtime/core-js/get-iterator.js
 ** module id = 317
 ** module chunks = 1
 **/